
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
export default {
components :{
XHeader,
Toast
},
data(){
return{
lang: "",
list: [
{ title: 'USDT', key: 'usd', image:'static/imgs/lang/india.png' }, //美元
{ title: 'EUR', key: 'eur', image:'static/imgs/lang/de.png' }, //欧元













]
}
},
created(){
this.lang = this.$i18n.locale || 'en'
},
methods: {
changeLang(lang){





},
setCookie(cname, cvalue, exdays) {

var d = new Date();

d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

var expires = "expires=" + d.toUTCString();

console.info(cname + "=" + cvalue + "; " + expires);

document.cookie = cname + "=" + cvalue + "; " + expires;

console.info(document.cookie);

}

}
}



// WEBPACK FOOTER //
// ./src/pages/unit.vue